import styled from 'styled-components';

export const LiveArenaWidgetCrownBox = styled.div`
    background: url(${props => props.theme.images.liveArena.liveArenaWidget.crown.toString()}) no-repeat;
    background-size: 60% 60%;
    background-position: center;
    height: 100%;
    width: 70px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 35px;
        height: 35px;
        flex-shrink: 0;
    }
`;
